<div class="ion-padding" (click)="dismiss()">
  <!--<script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
  <script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
  -->
  <!--|| Main Container ||-->
  <div class="pageContainer">

    <!--|| Header ||-->
    <div class="logoContainer">
      <img class="logoImg" src="/assets/imgs/logoColoured.png">
    </div>

    <!--|| Matches's Pictures ||-->
    <div class="soulsContainer">

      <!--| User |-->
      <div class="soulsBackground top">
        <div class="soulsMatch top">
          <img src="{{this.userData?.profilePic}}">
        </div> 
      </div>
      
      <!--| Match |-->
      <div class="soulsBackground bottom">
        <div class="soulsMatch bottom">
          <img [src]="this.likedSoul.firstPic">
        </div>  
      </div>

    </div>

    <!--||'VegMatch' Container ||-->
    <div class="matchTextContainer">
      <span>{{'vegMatch' | translate}}!</span>
    </div>

    <!--|| Footer Buttons Container ||-->
    <div class="btnContainer">

      <!--| Chat |-->
      <div class="btn chat"  (click)="chat(this.likedSoul)">
        <ion-icon name="chatbubbles" class="chatIcon"></ion-icon>
        <span class="btnText chat">{{'chat' | translate}}</span>
      </div>

      <!--| Next |-->
      <div class="btn next" (click)="dismiss()">
        <span class="btnText next">{{'backSurvey' | translate}}</span>
      </div>
    </div>
  </div>

</div>